import { createVNode as r, mergeProps as e } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/MaintainingFilledStandard.js";
import d from "../components/PfIcon.js";
const t = (a, i) => {
  const n = {
    ...a,
    ...i.attrs
  };
  return r(d, e(n, {
    icon: o
  }), null);
};
t.displayName = "MaintainingFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
